/**
 * Constants for Well Registration Totals report
 * @module wellRegistrationTotals/constants
 */

/** Current calendar year */
export const CURRENT_YEAR = new Date().getFullYear();

/** Available year options for the report (2026 onwards) */
export const YEAR_OPTIONS = Array.from(
  { length: CURRENT_YEAR - 2026 + 1 },
  (_, i) => 2026 + i
);

/** Month abbreviation to full name mapping */
export const MONTH_NAMES = {
  Jan: "January",
  Feb: "February",
  Mar: "March",
  Apr: "April",
  May: "May",
  Jun: "June",
  Jul: "July",
  Aug: "August",
  Sep: "September",
  Oct: "October",
  Nov: "November",
  Dec: "December",
};

/** CSV headers for drilldown wells export */
export const DRILLDOWN_CSV_HEADERS = [
  "Well #",
  "Name",
  "Address",
  "City",
  "Zip",
  "Aquifer",
  "Depth (ft)",
  "Use",
  "Status",
];

/** Row kinds that support click-through drilldown */
export const CLICKABLE_ROW_KINDS = ["month", "year_total"];

/** Row kinds that render with bold styling */
export const BOLD_ROW_KINDS = ["year_total", "grand_total", "adjusted_total"];

/** Row kinds that render the year column in bold */
export const BOLD_YEAR_COLUMN_KINDS = [
  "seed",
  "month",
  "year_total",
  "grand_total",
  "never_drilled",
  "plugged",
  "adjusted_total",
];
